import {get as _get, cloneDeep as _cloneDeep} from 'lodash';

const normalizeUserSearch = (userSearch, filters) => {
	const {userSearch: oldUserSearch = '', ...rest} = filters;
	const newFilters = {...rest};
	if (userSearch !== '') newFilters.userSearch = userSearch;
	return newFilters;
};

const normalizeFilters = (filters, stateFilters) => {
	let newFilters;

	if (_.isEmpty(stateFilters)) {
		newFilters = {
			filterTypes: {...stateFilters}
		};
	} else {
		newFilters = _cloneDeep(stateFilters);

		if (_.isEmpty(newFilters.filterTypes)) {
			newFilters.filterTypes = {};
		}
	}

	if (filters?.name) {
		newFilters.filterTypes[filters.name] = filters.value;
	}

	return newFilters;
};

export default (stateFilters, filterData) => {
	if (filterData?.userSearch !== undefined) return normalizeUserSearch(filterData.userSearch, stateFilters);
	if (filterData?.filters !== undefined) return normalizeFilters(filterData.filters, stateFilters);
	return {...stateFilters};
};
